import {type DropdownNs} from "@shared/types";

export const DefaultLanguageOptions: DropdownNs.DropdownOptionsItem = {
  name: 'English',
  value: 'English'
};

export const LanguageOptions: DropdownNs.DropdownOptionsItem[] = [
  {
    name: 'Türkçe',
    value: 'Türkçe'
  },
  {
    name: 'English',
    value: 'English'
  },
  {
    name: 'Deutsch',
    value: 'Deutsch'
  }
];

export const AiLanguageOptions: DropdownNs.DropdownOptionsItem[] = [
  {
    name: 'German',
    value: 'German'
  },
  {
    name: "French",
    value: "French"
  },
  {
    name: "Spanish",
    value: "Spanish"
  },
  {
    name: "Italian",
    value: "Italian"
  },
  {
    name: "Italian",
    value: "Italian"
  },
  {
    name: "Dutch",
    value: "Dutch"
  },
  {
    name: "Turkish",
    value: "Turkish"
  },
  {
    name: "Portuguese",
    value: "Portuguese"
  },
  {
    name: "Russian",
    value: "Russian"
  }
];
